import { render, staticRenderFns } from "./UniversesAppCard.vue?vue&type=template&id=08c7fa78&"
import script from "./UniversesAppCard.vue?vue&type=script&lang=ts&"
export * from "./UniversesAppCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports